import React from 'react';
import {Grid, Row, Col} from 'react-bootstrap';
import { PagePanel } from '../../../components/helpers/PagePanel';
import '../Home.css'

const About = () => (
    <PagePanel className="transparent information">
        <Grid>
            <Row>
                <Col xs={12} sm={6}>
                    <h1>The Conference</h1>
                    <p className="lead"><strong>GR8Conf</strong> brings you <strong>All Things
                        Groovy</strong></p>
                    <p className="lead">
                        Groovy, Grails, Gradle and the related technologies have seen astounding growth in interest and adoption the past few years,
                        and with good reason. To spread the word even more, we created GR8Conf.
                    </p>
                </Col>
                <Col xs={12} sm={6}>
                    <h1>Where and When</h1>
                    <p className="lead">Join us for <strong>three awesome</strong> conference days at
                        the <strong>IT-University of Copenhagen</strong> from <strong>May
                            30th</strong> to <strong>June 1st</strong>, 2018.</p>
                </Col>
            </Row>
        </Grid>
    </PagePanel>);

export default About;


// WEBPACK FOOTER //
// ./src/pages/home/fragments/About.js